var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 8.20939H6.66667V13.8274H5V8.20939H0V6.33673H5V0.71875H6.66667V6.33673H11.6667V8.20939Z",
    fill: "#7500C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPlus);
export default __webpack_public_path__ + "static/media/Vector_plus.6d155ee96c26692625d918b0bbe953fb.svg";
export { ForwardRef as ReactComponent };